import { initAccordeons } from "./accordeon";
import { CalcWidget } from "./calc";
import { CallbackForm } from "./callbackForm";
import { dataCompany } from "./data";
import { FeedbackForm } from "./FeedbackForm";
import { initMap } from "./map";
import { Modal } from "./modal";
import { RegForm } from "./RegViewForm";
import { ICompany, TMapItem } from "./types";



initAccordeons()
initMap()

CalcWidget()







const burger = document.getElementById('btn-menu');

burger?.addEventListener('click', function(){
  document.body.classList.toggle('mobile-nav-show')
})

const closeBtn = document.querySelector('.navbar-nav-close');

closeBtn?.addEventListener('click', function() {
  document.body.classList.remove('mobile-nav-show')
})














// ================================================================Swiper
document.querySelector(".qualities-slider") && new window.Swiper(".qualities-slider", {
  slidesPerView: 1,
  autoplay: {
    delay: 2500,
    disableOnInteraction: !1
  },
  pagination: {
    el: ".sp1",
    clickable: !0
  },
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 3
    },
    1100: {
      slidesPerView: 4
    }
  }
})



document.getElementById('warehouse_swiper') && new window.Swiper("#warehouse_swiper", {
  slidesPerView: 'auto',
  spaceBetween: 20,
  initialSlide: 1,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
      centeredSlides: true,
      navigation: {
        nextEl: '#warehouse-button-next',
        prevEl: '#warehouse-button-prev',
      },
    }
  },
});



























const callbackFormWrapper = document.getElementById('callbackFormWrapper')
if(callbackFormWrapper) {
  callbackFormWrapper.innerHTML = ''

  CallbackForm(callbackFormWrapper);
}

const feedbackFormWrapper = document.getElementById('feedbackFormWrapper')
if(feedbackFormWrapper) {
  feedbackFormWrapper.innerHTML = ''

  FeedbackForm(feedbackFormWrapper);
}


















const regBtn = document.getElementById('registerBtn') as HTMLButtonElement

if(regBtn) {

  regBtn.disabled = false


  const regModal = Modal({
    content: `<div class="p20"><h2 class="fz28 mb14">Записаться на просмотр</h2>
    <p class="mb24 fz14">Наш специалист перезвонит для подтверждения регистрации</p>
    <div data-form="true"></div></div>`,
    width: '460px',
  })

  const content = regModal.getContentElement();
  const formWrapper = content?.querySelector('[data-form]')

  RegForm(dataCompany.code, formWrapper);
  regBtn.addEventListener('click', ()=>{
    regModal.open()
  })
}













// ================================================================POPUP
// ================================================================POPUP


// initModal('book_modal', '.')


// function openModal(m) {
//   openedModals.add(m)
//   m.classList.add('open')
//   document.body.style.overflow = 'hidden'
// }
// function closeModal(m) {
//   openedModals.delete(m)
//   m.classList.remove('open')
//   document.body.style.overflow = 'unset'
// }
// const handleKeydown = (e) => {
//   if (e.key === 'Escape') {
//     openedModals.forEach(closeModal)
//   }
// }
// document.addEventListener('keydown', handleKeydown);
// ================================================================POPUP





const searchInput = document.getElementById('search') 

const cardsContainer = document.querySelector('.adress-card-items')

const companies: {[k: string]: ICompany} = window._dataCompanies ? JSON.parse(window._dataCompanies) : {}
const mapData = new Map<string, string>()
Object.values(companies).forEach(company => {
  mapData.set(company.code, company.address.toLowerCase())
})


if(cardsContainer && searchInput && companies) {
  const cardsList = cardsContainer?.querySelectorAll('[data-target]')
  searchInput.addEventListener('input', (event: any) =>{

    const query:string = event.target.value.toLowerCase()

    if(query.length > 2) {
      cardsList.forEach((card:any) => {
        const key = card.getAttribute('data-target')
        if(!key) return;
        const adress = mapData.get(key)
        const hasQuery = adress?.indexOf(query)

        if(hasQuery && hasQuery > -1) {
          card.style.display = 'flex'
        }else{          
          card.style.display = 'none'
        }
      }) 
    }else{
      cardsList.forEach((card:any) =>{
        card.style.display = 'flex'
      })
    }
  })

}
